import { render, staticRenderFns } from "./ruleconfig1.vue?vue&type=template&id=36eb5194&"
import script from "./ruleconfig1.vue?vue&type=script&lang=js&"
export * from "./ruleconfig1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports